<template>
    <div id="tenant-list-popup" class="tenant-list-popup">
        <vs-table
            noDataText="Nenhuma dash disponível para selecionar"
            pagination
            multiple
            :max-items="10"
            v-model="selected"
            :data="tenants"
        >
            <template slot="thead">
                <vs-th sort-key="name">
                    Nome da Plataforma
                </vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                    <vs-td :data="data[index].name">
                        {{ tr.fqdn.split(".")[0] }}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-button class="mr-6" @click="$emit('setTenants', selected)">
            Salvar
        </vs-button>
    </div>
</template>

<script>
    export default {
        name: 'TenantSlimList',
        props: {
            tenants: {
                type: Array,
                required: true
            },
            chosenTenants: {
                type: Array,
                required: true
            },
            addTenantPopupActive: {
                type: Boolean,
                required: true
            }
        },
        watch: {
            addTenantPopupActive(value) {
                if (value) {
                    this.selected = this.chosenTenants;
                }
            }
        },
        data() {
            return {
                selected: []
            }
        }
    }
</script>